var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fix-padding", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { attrs: { lg: "12" } },
        [
          _c("v-breadcrumbs", {
            staticClass: "p-0",
            attrs: { items: _vm.breadcrumbs },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.infor
        ? _c(
            "v-col",
            { staticClass: "pt-3 bg-white", attrs: { lg: "9" } },
            [
              _c(
                "div",
                { staticClass: "d-flex justify-space-between align-center" },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c("ButtonBack", {
                        nativeOn: {
                          click: function ($event) {
                            return _vm.back.apply(null, arguments)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "ms-2" }, [
                        _c("div", { staticClass: "text-large" }, [
                          _vm._v(_vm._s(_vm.infor.title)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-small" }, [
                          _vm._v(_vm._s(_vm.dateFormat(_vm.infor.createdAt))),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "text-small ms-2 border-default p-1 text-blue cursor-pointer",
                        on: { click: _vm.unread },
                      },
                      [_vm._v("\n          未読に戻す\n        ")]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "info-content" }, [
                _c("p", {
                  staticClass: "my-3 html-body",
                  domProps: { innerHTML: _vm._s(_vm.infor.content) },
                }),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }